import { RootState } from '@reducers';

export const selectCancerQuoteDetailsPage = (state: RootState) => state.cancerQuoteDetailsRouteReducer;
